(function () {
  var navigation = window.performance && performance.getEntriesByType('navigation')[0];
  var purchaseDomReady = document.readyState === 'complete' || Boolean(navigation && navigation.domContentLoadedEventStart);
  var purchaseDocumentReady = purchaseDomReady ? Promise.resolve() : new Promise(function (resolve) {
    document.addEventListener('DOMContentLoaded', function () {
      purchaseDomReady = true;
      resolve();
    }, { once: true });
  });
  function initClonedProductMedia(root) {
    var gallery = root.querySelector('[data-cloned-product-media]');
    if (!gallery) return;
    var more = gallery.querySelector('[data-cloned-media-more]');
    var hiddenCount = more ? more.textContent.trim() : '';
    var track = gallery.querySelector('.torras-cloned-product-media__grid');
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-cloned-media-item]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-cloned-media-thumb]'));
    var lightbox = null;
    var lightboxImage = null;
    var activeLightboxIndex = 0;
    var lightboxRequest = 0;
    var zoomImages = new Map();

    function getItemImage(index) {
      var item = items[index];
      return item ? item.querySelector('img') : null;
    }

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
    }

    function buildLightbox() {
      if (lightbox) return lightbox;

      lightbox = document.createElement('div');
      lightbox.className = 'torras-media-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Product media preview');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.setAttribute('data-analytics-component-id', 'pdp_media_gallery');
      lightbox.setAttribute('data-analytics-component-type', 'media_gallery');
      lightbox.innerHTML = [
        '<button type="button" class="torras-media-lightbox__button torras-media-lightbox__close" data-lightbox-close aria-label="Close product media preview" data-analytics-click data-analytics-impression data-analytics-element-type="button" data-analytics-element-id="lightbox_close" data-pdp-analytics-interaction="close">',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        '</button>',
        '<button type="button" class="torras-media-lightbox__button torras-media-lightbox__prev" data-lightbox-prev aria-label="Previous product image" data-analytics-click data-analytics-impression data-analytics-element-type="button" data-analytics-element-id="lightbox_previous" data-analytics-element-position="1" data-pdp-analytics-interaction="select_tab">',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</button>',
        '<img class="torras-media-lightbox__image" data-lightbox-image alt="">',
        '<button type="button" class="torras-media-lightbox__button torras-media-lightbox__next" data-lightbox-next aria-label="Next product image" data-analytics-click data-analytics-impression data-analytics-element-type="button" data-analytics-element-id="lightbox_next" data-analytics-element-position="2" data-pdp-analytics-interaction="select_tab">',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</button>'
      ].join('');

      lightboxImage = lightbox.querySelector('[data-lightbox-image]');
      document.body.appendChild(lightbox);

      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
      lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxImage(activeLightboxIndex - 1);
      });
      lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function (event) {
        event.stopPropagation();
        showLightboxImage(activeLightboxIndex + 1);
      });
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      return lightbox;
    }

    function updateLightboxControls() {
      if (!lightbox) return;
      var prev = lightbox.querySelector('[data-lightbox-prev]');
      var next = lightbox.querySelector('[data-lightbox-next]');
      if (prev) prev.disabled = activeLightboxIndex <= 0;
      if (next) next.disabled = activeLightboxIndex >= items.length - 1;
    }

    function getZoomSource(image) {
      var previewSource = image.dataset.productZoomSrc || image.currentSrc || image.src;
      if (root.dataset.productTemplate === 'youngkit-soft-touch-iphone-duo' ||
          root.dataset.productTemplate === 'youngkit-hidden-sand-iphone-duo' ||
          root.dataset.productTemplate === 'youngkit-extreme-wing-iphone-duo' ||
          root.dataset.productTemplate === 'q3-air-17pro-blazing-steed' ||
          root.dataset.productTemplate === 'q3-air-16pm-blazing-steed' ||
          root.dataset.productTemplate === 'o1s-18-pro' ||
          root.dataset.productTemplate === 'o3-air-18-series' ||
          root.dataset.productTemplate === 'o3-air-18pro' ||
          root.dataset.productTemplate === 'o3-air-18pm' ||
          root.dataset.productTemplate === 'o3-air-core-18-series' ||
          root.dataset.productTemplate === 'o3-air-core-18-pro-refresh' ||
          root.dataset.productTemplate === 'o3-air-core-18-pro-max-refresh' ||
          root.dataset.productTemplate === 'o1s-18-pro-max' ||
          root.dataset.productTemplate === 'ostand-o3-fitness-for-iphone-17-pro-max' ||
          root.dataset.productTemplate === 'ar-privacy-18-pro' ||
          root.dataset.productTemplate === 'ar-privacy-18-pro-max' ||
          root.dataset.productTemplate === 'glassgo-privacy-16-pro-17-2pack' ||
          root.dataset.productTemplate === 'glassgo-privacy-18-pro-2pack' ||
          root.dataset.productTemplate === 'glassgo-privacy-18-pro-max-2pack' ||
          root.dataset.productTemplate === 'pb19-dual-cable-10000mah' ||
          root.dataset.productTemplate === 'minimag-cable-power-bank-10k-mah' ||
          root.dataset.productTemplate === 'pearlgo-pro-power-bank-10k-mah' ||
          root.dataset.productTemplate === 'o1s-17-pro' ||
          root.dataset.productTemplate === 'o1s-17-pro-max' ||
          root.dataset.productTemplate === 'o3l-17-pro-max' ||
          root.dataset.productTemplate === 'o3l-18-pro-max' ||
          root.dataset.productTemplate === 'lpro-18-pro' ||
          root.dataset.productTemplate === 'lpro-18-pro-max' ||
          root.dataset.productTemplate === 'ostand-o3-air-summer-for-iphone-18-pro' ||
          root.dataset.productTemplate === 'ostand-o3-air-summer-for-iphone-18-pro-max' ||
          root.dataset.productTemplate === 'q3-pro-18-pro' ||
          root.dataset.productTemplate === 'q3-pro-18-pro-max' ||
          root.dataset.productTemplate === 'q3-pro-16-pro-max') {
        var originalUrl = new URL(previewSource, document.baseURI);
        originalUrl.searchParams.delete('width');
        originalUrl.searchParams.delete('height');
        previewSource = originalUrl.href;
      }
      return previewSource;
    }

    function prepareZoom(image) {
      var url = getZoomSource(image);
      if (zoomImages.has(url)) return zoomImages.get(url);
      var highResolution = new Image();
      highResolution.fetchPriority = 'low';
      highResolution.decoding = 'async';
      var ready = new Promise(function (resolve) {
        highResolution.onload = function () {
          var decoded = highResolution.decode ? highResolution.decode().catch(function () {}) : Promise.resolve();
          decoded.then(function () { resolve(highResolution); });
        };
        highResolution.onerror = function () {
          if (zoomImages.get(url) === record) zoomImages.delete(url);
          resolve(null);
        };
      });
      var record = { image: highResolution, ready: ready };
      zoomImages.set(url, record);
      if (zoomImages.size > 3) zoomImages.delete(zoomImages.keys().next().value);
      highResolution.src = url;
      return record;
    }

    function fitLightboxImage(target, source, width) {
      // Measure the existing CSS limits without changing the lightbox design.
      var probe = document.createElement('div');
      probe.className = 'torras-media-lightbox__image';
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;display:block;visibility:hidden;pointer-events:none;width:100000px;height:100000px';
      lightbox.appendChild(probe);
      var limits = probe.getBoundingClientRect();
      var padding = window.getComputedStyle(lightbox);
      var available = lightbox.clientWidth - parseFloat(padding.paddingLeft) - parseFloat(padding.paddingRight);
      var ratio = source.naturalWidth / source.naturalHeight || Number(source.getAttribute('width')) / Number(source.getAttribute('height')) || 1;
      var scale = Math.min(1, Math.min(limits.width, available) / width, limits.height / (width / ratio));
      target.style.width = (width * scale) + 'px';
      target.style.height = (width / ratio * scale) + 'px';
      probe.remove();
    }

    function showLightboxImage(index) {
      if (index < 0 || index >= items.length) return;
      buildLightbox();
      var image = getItemImage(index);
      if (!image || !lightboxImage) return;
      activeLightboxIndex = index;
      var request = ++lightboxRequest;
      var url = getZoomSource(image);
      var record = prepareZoom(image);
      record.image.fetchPriority = 'high';
      var preview = new Image();
      preview.className = 'torras-media-lightbox__image';
      preview.setAttribute('data-lightbox-image', '');
      preview.alt = image.alt || '';
      preview.src = image.currentSrc || image.src;
      var width = record.image.naturalWidth || Number(new URL(url, document.baseURI).searchParams.get('width')) || Number(image.getAttribute('width')) || 1200;
      fitLightboxImage(preview, image, width);
      lightboxImage.replaceWith(preview);
      lightboxImage = preview;
      updateLightboxControls();
      record.ready.then(function (loaded) {
        if (!loaded || request !== lightboxRequest || !lightbox.classList.contains('is-open')) return;
        loaded.className = 'torras-media-lightbox__image';
        loaded.setAttribute('data-lightbox-image', '');
        loaded.alt = image.alt || '';
        fitLightboxImage(loaded, image, loaded.naturalWidth);
        lightboxImage.replaceWith(loaded);
        lightboxImage = loaded;
      });
    }

    function openLightbox(index) {
      buildLightbox();
      lightbox.classList.add('is-open');
      showLightboxImage(index);
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('torras-media-lightbox-open');
      lightbox.querySelector('[data-lightbox-close]').focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightboxRequest += 1;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('torras-media-lightbox-open');
    }

    if (more) {
      more.setAttribute('aria-label', 'Show more product images');
      more.addEventListener('click', function () {
        var isExpanded = gallery.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        more.setAttribute('aria-label', isExpanded ? 'Show fewer product images' : 'Show more product images');
        more.textContent = isExpanded ? '-' : hiddenCount;
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        if (items[index]) {
          items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        setActiveThumb(index);
      });
    });

    items.forEach(function (item, index) {
      function warmZoom() {
        var image = getItemImage(index);
        if (image && !(navigator.connection && navigator.connection.saveData)) prepareZoom(image);
      }
      item.addEventListener('pointerenter', warmZoom, { passive: true });
      item.addEventListener('touchstart', warmZoom, { passive: true });
      item.addEventListener('focusin', warmZoom);
      item.addEventListener('click', function (event) {
        event.preventDefault();
        openLightbox(index);
      });
    });

    window.addEventListener('resize', function () {
      if (lightbox && lightbox.classList.contains('is-open')) showLightboxImage(activeLightboxIndex);
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showLightboxImage(activeLightboxIndex - 1);
      if (event.key === 'ArrowRight') showLightboxImage(activeLightboxIndex + 1);
    });

    if (track && items.length && thumbs.length) {
      track.addEventListener('scroll', function () {
        var itemWidth = items[0].getBoundingClientRect().width || 1;
        setActiveThumb(Math.round(track.scrollLeft / itemWidth));
      }, { passive: true });
    }
  }

  function initClonedDeviceColor(root, onChange) {
    var picker = root.querySelector('[data-cloned-device-color]');
    if (!picker) return null;
    var trigger = picker.querySelector('[data-cloned-device-color-trigger]');
    var label = picker.querySelector('[data-cloned-device-color-label]');
    var dot = picker.querySelector('[data-cloned-device-color-dot]');
    var options = Array.prototype.slice.call(picker.querySelectorAll('[data-cloned-device-color-option]'));
    if (!trigger || !label || !dot || !options.length) return null;

    function close() {
      picker.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function setActive(option) {
      options.forEach(function (item) {
        item.classList.toggle('is-active', item === option);
      });
      label.textContent = option.getAttribute('data-key') || '';
      dot.style.background = option.getAttribute('data-color') || '#cccccc';
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = picker.classList.contains('is-open');
      picker.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', (!isOpen).toString());
    });

    options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.stopPropagation();
        setActive(option);
        close();
        if (typeof onChange === 'function') onChange(option);
      });
    });

    document.addEventListener('click', function (event) {
      if (!picker.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    return {
      getSelectedKey: function () {
        var selected = options.find(function (item) {
          return item.classList.contains('is-active');
        }) || options[0];
        return selected ? selected.getAttribute('data-key') || '' : '';
      },
      setSelectedKey: function (key) {
        var normalizedKey = normalizeText(key);
        var option = options.find(function (item) {
          return normalizeText(item.getAttribute('data-key') || '') === normalizedKey;
        });
        if (option) setActive(option);
      }
    };
  }

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeImageToken(value) {
    return String(value || '')
      .replace(/^https?:/, '')
      .replace(/^\/\//, '')
      .replace(/&amp;/g, '&')
      .replace(/[?#].*$/, '')
      .toLowerCase();
  }

  function initDeviceDropdown(root) {
    var dropdown = root.querySelector('[data-device-dropdown]');
    if (!dropdown) return;
    var trigger = dropdown.querySelector('[data-device-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', (!isOpen).toString());
    });

    document.addEventListener('click', function (event) {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initJudgemePreview(root) {
    var badges = Array.prototype.slice.call(root.querySelectorAll('.torras-judgeme-preview .jdgm-preview-badge'));
    if (!badges.length) return;

    badges.forEach(function (badge) {
      if (badge.dataset.torrasJudgemePreviewReady === 'true') return;
      badge.dataset.torrasJudgemePreviewReady = 'true';

      var observer = null;
      var attempts = 0;
      var maxAttempts = 80;

      function isJudgemeStarFontReady() {
        var star = badge.querySelector('.jdgm-star');
        if (!star) return false;
        var fontFamily = window.getComputedStyle(star).fontFamily || '';
        if (fontFamily.indexOf('JudgemeStar') === -1) return false;
        if (!document.fonts || typeof document.fonts.check !== 'function') return true;
        return document.fonts.check('16px JudgemeStar');
      }

      function markReadyWhenLoaded() {
        attempts += 1;

        if (badge.classList.contains('jdgm--done-setup') && isJudgemeStarFontReady()) {
          badge.classList.add('is-ready');
          if (observer) observer.disconnect();
          return;
        }

        if (attempts < maxAttempts) {
          window.setTimeout(markReadyWhenLoaded, 100);
        }
      }

      if (window.MutationObserver) {
        observer = new MutationObserver(markReadyWhenLoaded);
        observer.observe(badge, { attributes: true, attributeFilter: ['class'] });
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(markReadyWhenLoaded).catch(function () {
          markReadyWhenLoaded();
        });
      }

      markReadyWhenLoaded();
    });
  }

  function initSection(root) {
    if (!root || root.dataset.mainProductReady === 'true') return;
    root.dataset.mainProductReady = 'true';

    initClonedProductMedia(root);
    initDeviceDropdown(root);
    initJudgemePreview(root);

    var gallery = root.querySelector('[data-cloned-product-media]');
    var mediaItems = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-cloned-media-item]')) : [];
    var mediaThumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-cloned-media-thumb]')) : [];
    var currentVariantInput = root.querySelector('[data-current-variant-id]');
    var priceRow = root.querySelector('[data-welcome-discount-product-price]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var selectedLabel = root.querySelector('[data-selected-label]');
    var optionSelectedLabels = Array.prototype.slice.call(root.querySelectorAll('[data-option-selected-label]'));
    var addToCart = root.querySelector('[data-add-to-cart]');
    var buyNow = root.querySelector('[data-buy-now]');
    var purchasePending = false;
    var quantityInput = root.querySelector('[data-quantity-input]');
    var quantityMinus = root.querySelector('[data-quantity-minus]');
    var quantityPlus = root.querySelector('[data-quantity-plus]');
    var formQuantity = root.querySelector('[data-form-quantity]');
    var totalQuantity = root.querySelector('[data-total-quantity]');
    var totalPrice = root.querySelector('[data-total-price]');
    var totalRow = root.querySelector('[data-unit-price-cents]');
    var details = root.querySelector('[data-product-details]');
    var detailsToggle = root.querySelector('[data-product-details-toggle]');
    var detailsMore = root.querySelector('[data-product-details-more]');
    var detailsContent = root.querySelector('[data-product-details-content]');
    var variantButtons = Array.prototype.slice.call(root.querySelectorAll('[data-variant-button]'));
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-option-button]'));
    var configEl = root.querySelector('[data-torras-main-product-config]');
    var config = {};
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent || '{}');
      } catch (error) {
        config = {};
      }
    }
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var colorOptionPosition = Number(config.colorOptionPosition || (selectedLabel ? selectedLabel.getAttribute('data-color-option-position') || '0' : 0));
    var phoneColorImageMappings = Array.isArray(config.phoneColorImageMappings)
      ? config.phoneColorImageMappings
        .filter(function (item) {
          return item && item.caseColor && item.phoneColor && item.imageUrl;
        })
        .sort(function (a, b) {
          return Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
        })
      : [];
    var devicePickerApi = null;

    function formatMoneyFallback(cents, format) {
      var formatString = format || '{{amount}}';
      var placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!placeholder) return formatString;

      var formats = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_with_space_separator: [2, ' ', ','],
        amount_no_decimals_with_space_separator: [0, ' ', ',']
      };
      var settings = formats[placeholder[1]] || formats.amount;
      var parts = (Number(cents || 0) / 100).toFixed(settings[0]).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, settings[1]);
      var value = parts.length > 1 ? whole + settings[2] + parts[1] : whole;

      return formatString.replace(placeholder[0], value);
    }

    function formatMoney(cents) {
      var moneyFormat = config.moneyFormat || '{{amount}}';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return formatMoneyFallback(cents, moneyFormat);
    }

    function getVariantOptionValue(variant, optionPosition) {
      if (!variant) return '';
      if (optionPosition === 1) return variant.option1 || '';
      if (optionPosition === 2) return variant.option2 || '';
      if (optionPosition === 3) return variant.option3 || '';
      return '';
    }

    function getCurrentVariant() {
      var currentVariantId = currentVariantInput ? Number(currentVariantInput.value || '0') : 0;
      return variants.find(function (item) {
        return item.id === currentVariantId;
      }) || variants[0] || null;
    }

    function getCurrentColorText(variant) {
      return getVariantOptionValue(variant || getCurrentVariant(), colorOptionPosition);
    }

    function getCurrentQuantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function setQuantity(value) {
      var quantity = Math.max(1, parseInt(value, 10) || 1);
      if (quantityInput) quantityInput.value = String(quantity);
      if (formQuantity) formQuantity.value = String(quantity);
      if (totalQuantity) totalQuantity.textContent = String(quantity);
      updateTotalPrice(getCurrentVariant());
    }

    function getEffectiveUnitPrice(variant) {
      var currentVariant = variant || getCurrentVariant();
      if (!currentVariant) return null;

      var effectivePriceValue = priceRow
        ? priceRow.getAttribute('data-welcome-discount-effective-price-cents')
        : null;
      if (effectivePriceValue !== null && effectivePriceValue !== '') {
        var effectivePrice = Number(effectivePriceValue);
        if (Number.isFinite(effectivePrice) && effectivePrice >= 0) return effectivePrice;
      }

      var overrideUnitPrice = totalRow && totalRow.getAttribute('data-price-overridden') === 'true'
        ? Number(totalRow.getAttribute('data-unit-price-cents') || '0')
        : 0;
      return overrideUnitPrice || currentVariant.price;
    }

    document.addEventListener('torras:launch-state', function () { updateTotalPrice(getCurrentVariant()); });

    function updateTotalPrice(variant) {
      if (!totalPrice) return;
      var effectiveUnitPrice = getEffectiveUnitPrice(variant);
      if (effectiveUnitPrice === null) return;
      var amount = effectiveUnitPrice * getCurrentQuantity();
      if (variant && root.querySelector('[data-launch-price-view]')?.hidden === false) {
        amount = variant.price * getCurrentQuantity();
        amount -= Math.floor(amount / 10);
      }
      totalPrice.textContent = formatMoney(amount);
    }

    function findPhoneColorMapping(variant) {
      if (!phoneColorImageMappings.length || !devicePickerApi) return null;
      var colorText = normalizeText(getCurrentColorText(variant));
      var phoneColorText = normalizeText(devicePickerApi.getSelectedKey());
      if (!colorText || !phoneColorText) return null;

      return phoneColorImageMappings.find(function (item) {
        return normalizeText(item.caseColor) === colorText && normalizeText(item.phoneColor) === phoneColorText;
      }) || null;
    }

    var pendingImageRequests = new WeakMap();

    function setImageSource(image, url) {
      if (!image || !url) return;
      var request = {};
      pendingImageRequests.set(image, request);
      // The server already renders the selected image. Keep its responsive request.
      var source = new URL(url, window.location.href);
      var current = new URL(image.getAttribute('src') || '', window.location.href);
      var sameShopifyPath = source.pathname.indexOf('/cdn/shop/') === 0 && source.pathname === current.pathname;
      if (sameShopifyPath || normalizeImageToken(current.href) === normalizeImageToken(source.href)) return;
      var isShopifyImage = /(^|\.)shopify\.com$/.test(source.hostname) || source.pathname.indexOf('/cdn/shop/') === 0;
      var replacement = image.cloneNode(false);
      replacement.dataset.productZoomSrc = url;
      replacement.loading = 'eager';
      replacement.removeAttribute('data-srcset');
      replacement.removeAttribute('data-src');
      if (isShopifyImage) {
        var thumbnail = Boolean(image.closest('[data-cloned-media-thumb]'));
        var widths = thumbnail ? [80, 120] : [360, 720, 1200];
        replacement.sizes = thumbnail ? '64px' : '(max-width: 989px) 350px, 620px';
        replacement.srcset = widths.map(function (width) {
          source.searchParams.set('width', width);
          return source.href + ' ' + width + 'w';
        }).join(', ');
        source.searchParams.set('width', widths[widths.length - 1]);
        replacement.src = source.href;
      } else {
        replacement.removeAttribute('srcset');
        replacement.src = url;
      }
      // Keep the current bitmap visible until the selected image is ready.
      // A slower request must never replace a more recently selected color.
      replacement.decode().then(function () {
        if (pendingImageRequests.get(image) !== request || !image.isConnected) return;
        replacement.alt = image.alt;
        image.replaceWith(replacement);
        pendingImageRequests.delete(image);
      }).catch(function () {
        // Preserve the working image if the new asset cannot be loaded.
        if (pendingImageRequests.get(image) === request) pendingImageRequests.delete(image);
      });
    }

    function getMediaImage(index) {
      var item = mediaItems[index];
      return item ? item.querySelector('img') : null;
    }

    function getVariantMediaUrl(variant) {
      if (!variant) return '';
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return variant.featured_media.preview_image.src;
      }
      if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      return '';
    }

    function getVariantMediaId(variant) {
      if (!variant) return '';
      if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
      if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
      return '';
    }

    function findMediaIndexById(id) {
      var target = String(id || '');
      if (!target) return -1;
      return mediaItems.findIndex(function (item) {
        return item && String(item.getAttribute('data-media-id') || '') === target;
      });
    }

    function findMediaIndexByUrl(url) {
      var target = normalizeImageToken(url);
      if (!target) return -1;
      var targetFile = target.split('/').pop();
      return mediaItems.findIndex(function (_item, index) {
        var item = mediaItems[index];
        var itemToken = normalizeImageToken(item ? item.getAttribute('data-media-src-token') || '' : '');
        if (targetFile && itemToken && itemToken === targetFile) return true;
        var image = getMediaImage(index);
        var current = normalizeImageToken(image ? image.currentSrc || image.src : '');
        return current === target || (targetFile && current.indexOf(targetFile) !== -1);
      });
    }

    function getPhoneColorSearchTerms(phoneColor) {
      var normalized = normalizeText(phoneColor);
      if (!normalized) return [];
      if (normalized.indexOf('silver') !== -1) return ['silver', 'sliver'];
      if (normalized.indexOf('orange') !== -1) return ['orange'];
      if (normalized.indexOf('blue') !== -1) return ['blue', 'deep'];
      return normalized.split(/\s+/).filter(Boolean);
    }

    function findMediaIndexByPhoneColor(phoneColor) {
      var terms = getPhoneColorSearchTerms(phoneColor);
      if (!terms.length) return -1;
      return mediaItems.findIndex(function (_item, index) {
        var image = getMediaImage(index);
        var current = normalizeImageToken(image ? image.currentSrc || image.src : '');
        return terms.some(function (term) {
          return current.indexOf(term) !== -1;
        });
      });
    }

    function setActiveMediaIndex(index) {
      mediaThumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
      if (mediaItems[index] && mediaItems[index].scrollIntoView) {
        mediaItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function applyPhoneColorImage(variant) {
      var mapping = findPhoneColorMapping(variant);
      if (!mediaItems.length) return false;
      if (!mapping) return false;

      var imageUrl = mapping.imageUrl;
      var thumbUrl = mapping.thumbUrl || mapping.imageUrl;
      var targetIndex = 0;
      var targetItem = mediaItems[targetIndex];
      var targetImage = targetItem ? targetItem.querySelector('img') : null;
      var targetThumb = mediaThumbs[targetIndex] ? mediaThumbs[targetIndex].querySelector('img') : null;

      setImageSource(targetImage, imageUrl);
      setImageSource(targetThumb, thumbUrl);
      if (targetImage) targetImage.alt = mapping.caseColor + ' / ' + mapping.phoneColor;
      if (targetThumb) targetThumb.alt = mapping.caseColor + ' / ' + mapping.phoneColor;
      if (gallery) {
        gallery.dataset.activeCaseColor = mapping.caseColor;
        gallery.dataset.activePhoneColor = mapping.phoneColor;
      }
      setActiveMediaIndex(targetIndex);
      return true;
    }

    function promoteMediaToHero(sourceIndex, variant) {
      if (!mediaItems.length || sourceIndex < 0) return false;
      // Keep every original image reachable when this product changes color.
      // Swapping the complete media records also keeps ID-based lookup and zoom aligned.
      if (['ostand-o3-air-classic-for-iphone-17-pro-max', 'o3-air-18pro', 'o3-air-18pm', 'youngkit-soft-touch-iphone-duo', 'youngkit-hidden-sand-iphone-duo', 'youngkit-extreme-wing-iphone-duo'].indexOf(root.dataset.productTemplate) !== -1) {
        if (sourceIndex > 0) {
          [mediaItems, mediaThumbs].forEach(function (records) {
            var hero = records[0];
            var selected = records[sourceIndex];
            if (!hero || !selected) return;
            var heroImage = hero.querySelector('img');
            var selectedImage = selected.querySelector('img');
            if (!heroImage || !selectedImage) return;
            hero.replaceChild(selectedImage, heroImage);
            selected.appendChild(heroImage);
            ['data-media-id', 'data-media-src-token', 'aria-label', 'data-analytics-element-id'].forEach(function (attribute) {
              var original = hero.getAttribute(attribute);
              hero.setAttribute(attribute, selected.getAttribute(attribute) || '');
              selected.setAttribute(attribute, original || '');
            });
          });
        }
        setActiveMediaIndex(0);
        return true;
      }
      var targetIndex = 0;
      var sourceItem = mediaItems[sourceIndex];
      var sourceThumb = mediaThumbs[sourceIndex];
      var sourceImage = sourceItem ? sourceItem.querySelector('img') : null;
      var sourceThumbImage = sourceThumb ? sourceThumb.querySelector('img') : null;
      var targetItem = mediaItems[targetIndex];
      var targetThumb = mediaThumbs[targetIndex];
      var targetImage = targetItem ? targetItem.querySelector('img') : null;
      var targetThumbImage = targetThumb ? targetThumb.querySelector('img') : null;
      var imageUrl = getVariantMediaUrl(variant) || (sourceImage && (sourceImage.currentSrc || sourceImage.src));
      var thumbUrl = sourceIndex > 0 && sourceThumbImage ? sourceThumbImage.currentSrc || sourceThumbImage.src : imageUrl;
      var mediaAlt = (sourceItem && sourceItem.getAttribute('aria-label')) || (sourceImage && sourceImage.alt) || (variant && variant.title) || '';

      if (!targetImage || !imageUrl) return false;
      setImageSource(targetImage, imageUrl);
      if (targetThumbImage) setImageSource(targetThumbImage, thumbUrl);
      targetImage.alt = mediaAlt;
      if (targetThumbImage) targetThumbImage.alt = mediaAlt;
      setActiveMediaIndex(targetIndex);
      return true;
    }

    function applyVariantFeaturedMedia(variant) {
      var targetIndex = findMediaIndexById(getVariantMediaId(variant));
      if (targetIndex < 0) targetIndex = findMediaIndexByUrl(getVariantMediaUrl(variant));
      if (targetIndex < 0) return false;
      return promoteMediaToHero(targetIndex, variant);
    }

    function applyPhoneColorFallbackMedia() {
      if (!devicePickerApi || phoneColorImageMappings.length) return false;
      var targetIndex = findMediaIndexByPhoneColor(devicePickerApi.getSelectedKey());
      if (targetIndex < 0) return false;
      setActiveMediaIndex(targetIndex);
      return true;
    }

    function setAvailability(variant) {
      if (!addToCart) return;
      var isAvailable = (!variant || variant.available !== false) && !purchasePending;
      addToCart.disabled = !isAvailable;
      if (buyNow) buyNow.disabled = !isAvailable;
    }

    function trackBuyNowResult(result) {
      if (!buyNow) return;
      window.TorrasAnalytics?.trackInteraction(buyNow, {
        elementType: 'cta',
        elementId: 'buy_now',
        elementPosition: 2,
        interactionName: 'submit',
        interactionResult: result,
      });
    }

    function setActiveButtons(buttons, activeButton) {
      buttons.forEach(function (button) {
        var isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function setActiveButtonsByColor(colorText) {
      if (!colorText) return;
      variantButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-variant-color') === colorText;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateSelectedOptionLabels(variant) {
      if (!variant || !optionSelectedLabels.length) return;
      optionSelectedLabels.forEach(function (label) {
        var pos = Number(label.getAttribute('data-option-position') || '0');
        if (!pos) return;
        var optionText = getVariantOptionValue(variant, pos);
        if (optionText) label.textContent = optionText;
      });
    }

    function syncGenericOptionButtons(variant) {
      if (!variant || !optionButtons.length) return;
      optionButtons.forEach(function (button) {
        var pos = Number(button.getAttribute('data-option-position') || '0');
        var optionValue = button.getAttribute('data-option-value') || '';
        var isActive = pos > 0 && getVariantOptionValue(variant, pos) === optionValue;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function findVariantByOptionValue(optionPosition, desiredValue) {
      if (!desiredValue || !variants.length) return null;
      if (optionPosition < 1 || optionPosition > 3) return null;
      var key = 'option' + optionPosition;
      var currentVariantId = currentVariantInput ? Number(currentVariantInput.value || '0') : 0;
      var currentVariant =
        variants.find(function (item) {
          return item.id === currentVariantId;
        }) || variants[0];

      if (currentVariant) {
        var exactMatch = variants.find(function (item) {
          if (item[key] !== desiredValue) return false;
          var matchesOtherOptions = true;
          [1, 2, 3].forEach(function (optionIndex) {
            var optionKey = 'option' + optionIndex;
            if (optionKey !== key && currentVariant[optionKey] && item[optionKey] !== currentVariant[optionKey]) {
              matchesOtherOptions = false;
            }
          });
          return matchesOtherOptions;
        });
        if (exactMatch) return exactMatch;
      }

      return (
        variants.find(function (item) {
          return item[key] === desiredValue;
        }) || null
      );
    }

    function findVariantByColor(colorText) {
      if (!colorText || !variants.length) return null;
      var pos = selectedLabel ? Number(selectedLabel.getAttribute('data-color-option-position') || '0') : 0;
      var key = pos >= 1 && pos <= 3 ? 'option' + pos : '';
      var currentVariantId = currentVariantInput ? Number(currentVariantInput.value || '0') : 0;
      var currentVariant = variants.find(function (item) {
        return item.id === currentVariantId;
      }) || variants[0];

      if (key && currentVariant) {
        var exactMatch = variants.find(function (item) {
          if (item[key] !== colorText) return false;
          var matchesOtherOptions = true;
          [1, 2, 3].forEach(function (optionIndex) {
            var optionKey = 'option' + optionIndex;
            if (optionKey !== key && currentVariant[optionKey] && item[optionKey] !== currentVariant[optionKey]) {
              matchesOtherOptions = false;
            }
          });
          return matchesOtherOptions;
        });
        if (exactMatch) return exactMatch;
      }

      return variants.find(function (item) {
        return key ? item[key] === colorText : item.title === colorText;
      }) || null;
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (currentVariantInput) {
        currentVariantInput.value = String(variant.id);
        currentVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateSelectedOptionLabels(variant);
      syncGenericOptionButtons(variant);

      var overrideUnitPrice = totalRow && totalRow.getAttribute('data-price-overridden') === 'true'
        ? Number(totalRow.getAttribute('data-unit-price-cents') || '0')
        : 0;
      var displayPriceCents = overrideUnitPrice || variant.price;
      if (priceCurrent) priceCurrent.textContent = formatMoney(displayPriceCents);
      var launchPrice = root.querySelector('[data-launch-pdp-price] [data-launch-price]');
      if (launchPrice) {
        launchPrice.dataset.originalCents = String(variant.price);
        launchPrice.querySelector('s').textContent = formatMoney(variant.price);
        launchPrice.querySelector('strong').textContent = formatMoney(variant.price - Math.floor(variant.price / 10));
      }
      if (priceRow) priceRow.setAttribute('data-welcome-discount-price-cents', String(displayPriceCents));
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(variant.compare_at_price);
        } else {
          priceCompare.hidden = true;
          priceCompare.textContent = '';
        }
      }

      setAvailability(variant);
      updateTotalPrice(variant);
      var colorText = getCurrentColorText(variant);
      if (colorText) setActiveButtonsByColor(colorText);
      if (!applyPhoneColorImage(variant) && !applyVariantFeaturedMedia(variant)) {
        applyPhoneColorFallbackMedia();
      }
    }

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var colorValue = button.getAttribute('data-variant-color');
        var variantId = Number(button.getAttribute('data-variant-id'));
        var variant = findVariantByColor(colorValue) || variants.find(function (item) {
          return item.id === variantId;
        });
        if (!variant) return;

        setActiveButtons(variantButtons, button);
        applyVariant(variant);
      });
    });

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var optionPosition = Number(button.getAttribute('data-option-position') || '0');
        var optionValue = button.getAttribute('data-option-value');
        var variant = findVariantByOptionValue(optionPosition, optionValue);
        if (!variant) return;
        applyVariant(variant);
      });
    });

    function purchaseError(error) {
      var form = root.querySelector('product-form');
      var message = error && error.message || (window.cartStrings && window.cartStrings.error) || 'Unable to complete this request. Please try again.';
      var errorWrapper = root.querySelector('.product-form__error-message-wrapper');
      var actions = errorWrapper && errorWrapper.closest('.torras-main-product__actions');
      if (actions) actions.before(errorWrapper);
      if (form && typeof form.handleErrorMessage === 'function') form.handleErrorMessage(message);
      else {
        var wrapper = root.querySelector('.product-form__error-message-wrapper');
        var text = root.querySelector('.product-form__error-message');
        if (text) text.textContent = message;
        if (wrapper) wrapper.hidden = false;
      }
    }

    function purchaseSnapshot(mode) {
      var form = root.querySelector('[data-product-form]');
      var data = mode === 'add' ? new FormData(form) : new FormData();
      var id = currentVariantInput.value;
      data.set('id', id);
      data.set('quantity', String(getCurrentQuantity()));
      var pairing = form && document.getElementById('Pairings-' + form.getAttribute('id'));
      var hasPairing = Boolean(pairing && typeof pairing.appendToCartData === 'function' && pairing.appendToCartData(data));
      return { formData: data, variantId: id, hasPairing: hasPairing };
    }

    function setPurchaseWaiting(mode, waiting) {
      purchasePending = waiting;
      [addToCart, buyNow].forEach(function (button) {
        if (button) {
          if (waiting) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        }
      });
      if (mode === 'add' && addToCart) {
        addToCart.classList.toggle('loading', waiting);
        var spinner = addToCart.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !waiting);
      }
      setAvailability(getCurrentVariant());
      document.querySelectorAll('[data-mobile-product-add], [data-mobile-product-buy]').forEach(function (button) {
        var source = button.hasAttribute('data-mobile-product-buy') ? buyNow : addToCart;
        button.disabled = waiting || Boolean(source && (source.disabled || source.getAttribute('aria-disabled') === 'true'));
        if (waiting) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
        if (mode === 'add' && button.hasAttribute('data-mobile-product-add')) {
          button.classList.toggle('loading', waiting);
          var spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.toggle('hidden', !waiting);
        }
      });
    }

    function startBuyNow(snapshot) {
      var formElement = root.querySelector('product-form');
      if (formElement && typeof formElement.handleErrorMessage === 'function') formElement.handleErrorMessage();
      buyNow.setAttribute('aria-busy', 'true');
      buyNow.disabled = true;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: snapshot.formData
      })
        .then(async function (response) {
          if (!response || !response.ok) {
            var failure = response && await response.json().catch(function () { return null; });
            throw new Error(failure && failure.description || window.cartStrings.error);
          }
          trackBuyNowResult('success');
          var checkoutAllowed = window.TorrasLaunch && await window.TorrasLaunch.beforeCheckout();
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + (checkoutAllowed ? 'checkout' : 'cart');
        })
        .catch(function (error) {
          trackBuyNowResult('error');
          purchaseError(error);
        })
        .finally(function () {
          buyNow.removeAttribute('aria-busy');
          setAvailability(getCurrentVariant());
        });
    }

    function queuePurchase(mode) {
      var button = mode === 'add' ? addToCart : buyNow;
      if (!button || purchasePending || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') return;
      // Capture the clicked variant, quantity, properties and pairings before waiting.
      var snapshot = purchaseSnapshot(mode);
      setPurchaseWaiting(mode, true);
      purchaseDocumentReady.then(function () {
        var formElement = root.querySelector('product-form');
        if (!formElement || typeof formElement.onSubmitHandler !== 'function') throw new Error(window.cartStrings && window.cartStrings.error);
        setPurchaseWaiting(mode, false);
        if (mode === 'buy') startBuyNow(snapshot);
        else {
          var form = root.querySelector('[data-product-form]');
          form.dispatchEvent(new CustomEvent('submit', { bubbles: true, cancelable: true, detail: { torrasPurchase: snapshot } }));
        }
      }).catch(function (error) {
        setPurchaseWaiting(mode, false);
        purchaseError(error);
      });
    }

    var purchaseForm = root.querySelector('[data-product-form]');
    if (purchaseForm) purchaseForm.addEventListener('submit', function (event) {
      if (event.detail && event.detail.torrasPurchase) return;
      var formElement = root.querySelector('product-form');
      if (purchasePending || !purchaseDomReady || !formElement || typeof formElement.onSubmitHandler !== 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!purchasePending) queuePurchase('add');
      }
    }, true);
    if (buyNow && currentVariantInput) buyNow.addEventListener('click', function () { queuePurchase('buy'); });
    document.addEventListener('click', function (event) {
      var mobile = event.target.closest('[data-mobile-product-add], [data-mobile-product-buy]');
      if (!mobile || !root.isConnected || root !== document.querySelector('.torras-main-product')) return;
      if (!purchasePending && purchaseDomReady && customElements.get('mobile-product-purchase-bar')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!purchasePending) queuePurchase(mobile.hasAttribute('data-mobile-product-buy') ? 'buy' : 'add');
    }, true);

    if (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        setQuantity(getCurrentQuantity() - 1);
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        setQuantity(getCurrentQuantity() + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        setQuantity(quantityInput.value);
      });
      quantityInput.addEventListener('input', function () {
        if (quantityInput.value) setQuantity(quantityInput.value);
      });
    }

    if (priceRow && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        updateTotalPrice(getCurrentVariant());
      }).observe(priceRow, {
        attributes: true,
        attributeFilter: ['data-welcome-discount-effective-price-cents']
      });
    }

    if (details && detailsToggle) {
      detailsToggle.addEventListener('click', function () {
        var expanded = details.getAttribute('data-expanded') !== 'false';
        details.setAttribute('data-expanded', expanded ? 'false' : 'true');
        detailsToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        detailsToggle.querySelector('span:last-child').textContent = expanded ? '+' : '-';
      });
    }

    if (detailsMore && detailsContent) {
      detailsMore.addEventListener('click', function () {
        var expanded = detailsMore.getAttribute('aria-expanded') === 'true';
        detailsMore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        detailsMore.querySelector('span').textContent = expanded ? 'Show more' : 'Show less';
        detailsContent.classList.toggle('is-clamped', expanded);
      });
    }

    var initialVariant = variants.find(function (variant) {
      return currentVariantInput && String(variant.id) === currentVariantInput.value;
    });
    devicePickerApi = initClonedDeviceColor(root, function () {
      if (!applyPhoneColorImage(getCurrentVariant())) applyPhoneColorFallbackMedia();
    });
    setAvailability(initialVariant);
    updateSelectedOptionLabels(initialVariant);
    syncGenericOptionButtons(initialVariant);
    setQuantity(getCurrentQuantity());
    if (!applyPhoneColorImage(initialVariant) && !applyVariantFeaturedMedia(initialVariant)) {
      applyPhoneColorFallbackMedia();
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('.torras-main-product');
    Array.prototype.forEach.call(roots, function (root) {
      // Async loading must never bind a partially parsed product or JSON config.
      if (document.readyState === 'loading' && !root.querySelector('[data-main-product-complete]')) return;
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    var readyObserver = new MutationObserver(function () {
      if (!document.querySelector('.torras-main-product [data-main-product-complete]')) return;
      boot(document);
      readyObserver.disconnect();
    });
    readyObserver.observe(document.documentElement, { childList: true, subtree: true });
    boot(document);
    document.addEventListener('DOMContentLoaded', function () {
      readyObserver.disconnect();
      boot(document);
    }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    boot(event.target);
  });
})();
